import React from 'react';
import { HeroSection } from '../components/SalesLetter/HeroSection';
import { OpeningHook } from '../components/SalesLetter/OpeningHook';
import { PainTable } from '../components/SalesLetter/PainTable';
import { SolutionSection } from '../components/SalesLetter/SolutionSection';
import { WhatYouGet } from '../components/SalesLetter/WhatYouGet';
import { WhoIsItFor } from '../components/SalesLetter/WhoIsItFor';
import { TestimonialSection } from '../components/SalesLetter/TestimonialSection';
import { FAQSection } from '../components/SalesLetter/FAQSection';
import { OfferSection } from '../components/SalesLetter/OfferSection';
import { Footer } from '../components/SalesLetter/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-navy-dark selection:bg-gold-primary/30 selection:text-white" data-id="element-192">
      <HeroSection data-id="element-193" />
      <OpeningHook data-id="element-194" />
      <PainTable data-id="element-195" />
      <SolutionSection data-id="element-196" />
      <WhatYouGet data-id="element-197" />
      <WhoIsItFor data-id="element-198" />
      <TestimonialSection data-id="element-199" />
      <FAQSection data-id="element-200" />
      <OfferSection data-id="element-201" />
      <Footer data-id="element-202" />
    </main>;
}